// Same people as Administration::ProformaClaimPolicy::ALLOWED_USER_IDS.
import { Store } from "modules/0_web/1_entry";

export const PROFORMA_CLAIM_USER_IDS = [1, 77, 44];

export const canUseProformaClaims = () => {
  const id = Number(Store.getState()?.current_user?.id);
  return PROFORMA_CLAIM_USER_IDS.includes(id);
};
